module.exports = require("../../../../lib").stronachgroup.first.extensions;
